import updateGraph from "./updateGraph"

const addEdgeAndUpdateGraph = (edge, graph, topic, setGraph) => {
    let newGraph = JSON.parse(JSON.stringify(graph));
    newGraph.edges.push(edge.toObject());
    setGraph(newGraph);
    updateGraph({ topic, newGraph })
}

export default addEdgeAndUpdateGraph